import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Layout from '../../components/layouts/Homepage';
import SEO from '../../components/seo';
import Homepage from '../../components/homepage/Homepage';
import { NotificationBarConsumer, DropZoneConsumer } from '@mdc/ui';
import { ThemeProvider } from '@mdc/services';

import './Homepage.scss';


const IndexPage = () => {

    const bgImages = useStaticQuery(graphql`
        query bgImagesCity {
            default: allFile(filter: { sourceInstanceName: { eq: "cityBackgrounds" }, extension: { eq: "jpg" }, relativePath: { regex: "/^backgrounds/" }, name: { regex: "/_001|_002/"} }) {
                edges {
                    node {
                        publicURL
                        name
                        childImageSharp {
                            fluid(quality: 100, maxWidth: 2560) {
                            ...GatsbyImageSharpFluid_withWebp
                            }
                        }
                    }
                }
            }
        }
    `);

    return (
        <ThemeProvider>
            <NotificationBarConsumer>
                <Layout>
                    <SEO title="Advanced threat prevention and detection" theme="city" />
                    <DropZoneConsumer>
                        <Homepage bgImages={bgImages}/>
                    </DropZoneConsumer>
                </Layout>
            </NotificationBarConsumer>
        </ThemeProvider>
    );
};

export default IndexPage;
